import { z } from 'zod';

/**
 * Canonical John Doe identity `/auth/dev-login` falls back to without an
 * override. Shared by the server route and the web login screen's Vite-dev
 * fallback so the two cannot drift.
 */
export const DEV_LOGIN_DEFAULT_EMAIL = 'johndoe@example.com';

/**
 * Placeholder `RUNLOOP_API_KEY` seeded by `/auth/dev-bootstrap` when
 * `REFLEX_FAKE_SANDBOX` is set. Kept in one place so the e2e harness and the
 * seeded-preview finalize path cannot drift on the value.
 */
export const DEV_BOOTSTRAP_FAKE_RUNLOOP_KEY = 'reflex-e2e-fake-key';

/**
 * Optional body for `POST /auth/dev-bootstrap`. When `orgSlug` is set, the
 * hook targets that membership instead of creating/reusing `existing[0]`
 * (the seeded-preview wrapper passes the seed's org slug).
 */
export const DevBootstrapRequestSchema = z.object({
  orgSlug: z.string().min(1).optional(),
});
export type DevBootstrapRequest = z.infer<typeof DevBootstrapRequestSchema>;

/** Response from `POST /auth/dev-bootstrap`. */
export const DevBootstrapResponseSchema = z.object({
  orgId: z.string().min(1),
  orgSlug: z.string().min(1),
});
export type DevBootstrapResponse = z.infer<typeof DevBootstrapResponseSchema>;
